var map = {
	"./Round_1/Atlas_Thumb.png": 31,
	"./Round_1/Building_Community_Header.png": 32,
	"./Round_1/Building_Community_Thumb.png": 33,
	"./Round_1/Mira_MVP_Thumb.png": 34,
	"./Round_1/Search_Engine_Thumb.png": 35,
	"./Round_1/T_Mobile_Thumb.png": 36,
	"./Round_1/Tin_Pan_Thumb.png": 37,
	"./Round_2/autodesk_atlas_thumb.png": 38,
	"./Round_2/book_nation_thumb.png": 39,
	"./Round_2/fbtb_thumb.png": 40,
	"./Round_2/mira_community_thumb.png": 41,
	"./Round_2/mira_mvp_thumb.png": 42,
	"./Round_2/mira_search_thumb.png": 43,
	"./autodesk_atlas/autodesk_atlas_t_header.png": 44,
	"./autodesk_atlas_thumb.png": 45,
	"./blank_case_img.png": 46,
	"./book_nation/barriers_to_literacy.png": 47,
	"./book_nation/blank_case_img.png": 48,
	"./book_nation/bn_brand_kit_closeup.png": 49,
	"./book_nation/bn_figma.png": 50,
	"./book_nation/bn_final_branding.png": 51,
	"./book_nation/bn_final_logo.png": 52,
	"./book_nation/bn_inspiration_logos.png": 53,
	"./book_nation/bn_literacy_matters.png": 54,
	"./book_nation/bn_logo_blur.png": 55,
	"./book_nation/bn_logo_sketches.png": 56,
	"./book_nation/bn_logos_selection.png": 57,
	"./book_nation/bn_logos_selection_blur.png": 58,
	"./book_nation/bn_logos_selection_flat.png": 59,
	"./book_nation/bn_synthesis1.png": 60,
	"./book_nation/bn_synthesis2.png": 61,
	"./book_nation/bn_team.png": 62,
	"./book_nation/bn_website_copy.png": 63,
	"./book_nation/bn_wix_dash.png": 64,
	"./book_nation/bn_wix_editing.png": 65,
	"./book_nation/bn_wix_template.png": 66,
	"./book_nation/book_nation_header.png": 9,
	"./book_nation/book_nation_header_books.png": 67,
	"./book_nation/book_nation_t_header.png": 68,
	"./book_nation/core_task.png": 69,
	"./book_nation/interview_transcript.png": 70,
	"./book_nation/interview_transcript_flat.png": 71,
	"./book_nation/literacy_is_the_foundation.png": 72,
	"./book_nation/literacy_programs.png": 73,
	"./book_nation/metaphor.png": 74,
	"./book_nation/site_files.png": 75,
	"./book_nation/wix_comparison.png": 76,
	"./book_nation_thumb.png": 77,
	"./fbtb/Screen Shot 2021-10-12 at 10.18.40 PM.png": 78,
	"./fbtb/Screen Shot 2021-10-12 at 9.47.19 PM.png": 79,
	"./fbtb/Screen Shot 2021-10-12 at 9.47.59 PM.png": 80,
	"./fbtb/aesthetic_inspo.png": 81,
	"./fbtb/blank_case_img.png": 82,
	"./fbtb/branding_header.png": 83,
	"./fbtb/christopher_farmers_market.jpeg": 84,
	"./fbtb/christopher_headshot.jpeg": 85,
	"./fbtb/competitor_brand_analysis.png": 86,
	"./fbtb/content_outline.png": 87,
	"./fbtb/delivery_comms.png": 88,
	"./fbtb/delivery_routes.png": 89,
	"./fbtb/delivery_spreadsheet.png": 90,
	"./fbtb/delivery_spreadsheet_blur.png": 91,
	"./fbtb/dream_photo.jpeg": 92,
	"./fbtb/dream_photo_2.jpeg": 93,
	"./fbtb/edward_headshot.jpeg": 94,
	"./fbtb/electric_car.png": 95,
	"./fbtb/farmers_list.png": 96,
	"./fbtb/farmers_list_blur.png": 97,
	"./fbtb/farmers_list_blur2.png": 98,
	"./fbtb/farmers_market_fruit.jpeg": 99,
	"./fbtb/farmers_market_stand.jpeg": 100,
	"./fbtb/farmers_market_stand_2.jpeg": 101,
	"./fbtb/fbtb_bg_photo.png": 102,
	"./fbtb/fbtb_figma.png": 103,
	"./fbtb/fbtb_header.png": 10,
	"./fbtb/fbtb_homepage.png": 104,
	"./fbtb/fbtb_how_it_works.png": 105,
	"./fbtb/fbtb_logo_card_1.png": 106,
	"./fbtb/fbtb_logo_card_2.png": 107,
	"./fbtb/fbtb_logo_sketches.jpeg": 108,
	"./fbtb/fbtb_logo_sketches.png": 109,
	"./fbtb/fbtb_photo_card.jpeg": 110,
	"./fbtb/fbtb_react.png": 111,
	"./fbtb/fbtb_refined_logo.png": 112,
	"./fbtb/fbtb_t_header.png": 113,
	"./fbtb/flyer_side_1.png": 114,
	"./fbtb/flyer_side_2.png": 115,
	"./fbtb/fruit_boxes.jpeg": 116,
	"./fbtb/fruit_boxes.jpg": 117,
	"./fbtb/fruit_jesus_1.jpeg": 118,
	"./fbtb/fruit_jesus_1.png": 119,
	"./fbtb/fruit_jesus_2.jpeg": 120,
	"./fbtb/fruit_jesus_3.jpeg": 121,
	"./fbtb/fruit_jesus_4.jpeg": 122,
	"./fbtb/fruit_jesus_5.jpeg": 123,
	"./fbtb/fruit_kitchen.jpeg": 124,
	"./fbtb/fruit_research.png": 125,
	"./fbtb/fruit_sorting.jpeg": 126,
	"./fbtb/fruit_truck.jpeg": 127,
	"./fbtb/konstantin_profile.png": 128,
	"./fbtb/marketing_header.jpeg": 129,
	"./fbtb/new_client_flow_sketch.jpeg": 130,
	"./fbtb/new_order_header.png": 131,
	"./fbtb/office_fruit.jpeg": 132,
	"./fbtb/operations_header.jpeg": 133,
	"./fbtb/shen_headshot.jpeg": 134,
	"./fbtb/survey_probe.png": 135,
	"./fbtb/technical_outline.jpeg": 136,
	"./fbtb/town_fridge.png": 137,
	"./fbtb/user_interviews.png": 138,
	"./fbtb/ux_operations_sketch.jpeg": 139,
	"./fbtb/website_coupon_code.png": 140,
	"./fbtb/website_coupon_code_blur.png": 141,
	"./fbtb_thumb.png": 142,
	"./mira_community/blank_case_img.png": 143,
	"./mira_community/mira_community_header.png": 144,
	"./mira_community/mira_community_header_bg_tiles.png": 145,
	"./mira_community/mira_community_t_header.png": 146,
	"./mira_community_thumb.png": 147,
	"./mira_mvp/blank_case_img.png": 148,
	"./mira_mvp/mira_mvp_header.jpeg": 149,
	"./mira_mvp/mira_mvp_header.png": 150,
	"./mira_mvp/mira_mvp_t_header.png": 11,
	"./mira_mvp/search_web_1.png": 151,
	"./mira_mvp_thumb.png": 152,
	"./mira_search/Comm_Rest_4.gif": 153,
	"./mira_search/Facebook Search.png": 154,
	"./mira_search/IMG_20180530_120424.jpg": 155,
	"./mira_search/IMG_20180615_154102.jpg": 156,
	"./mira_search/IMG_20190212_135106.jpg": 157,
	"./mira_search/MAKENZY – IDEAL PROCESS.gif": 158,
	"./mira_search/MAKENZY – IDEAL PROCESS_1.gif": 159,
	"./mira_search/Macbook Quickfind.png": 160,
	"./mira_search/MiraAlpha_searchiterations_11092017.jpg": 161,
	"./mira_search/blank_case_img.png": 162,
	"./mira_search/card_sort_smaller.gif": 163,
	"./mira_search/card_sorting.gif": 164,
	"./mira_search/card_sorting_bright.gif": 165,
	"./mira_search/component_library.png": 166,
	"./mira_search/component_library_type.png": 167,
	"./mira_search/decision_making_1.png": 168,
	"./mira_search/decision_making_1_closeup.png": 169,
	"./mira_search/decision_making_2.png": 170,
	"./mira_search/decision_making_3.png": 171,
	"./mira_search/decision_making_4.png": 172,
	"./mira_search/ezgif.com-optimize (2).gif": 173,
	"./mira_search/ezgif.com-optimize (3).gif": 174,
	"./mira_search/full_story.png": 175,
	"./mira_search/full_story_big.png": 176,
	"./mira_search/journey_map_pain_points.png": 177,
	"./mira_search/logo_revision.png": 178,
	"./mira_search/logo_test_1.gif": 179,
	"./mira_search/mira_app_logo.png": 180,
	"./mira_search/mira_appstore_screens.png": 181,
	"./mira_search/mira_decision_browsing.png": 182,
	"./mira_search/mira_decision_text_search.png": 183,
	"./mira_search/mira_launch.png": 184,
	"./mira_search/mira_launch_1.jpeg": 185,
	"./mira_search/mira_launch_2.jpeg": 186,
	"./mira_search/mira_launch_3.jpeg": 187,
	"./mira_search/mira_logo_animation_sequence (1).png": 188,
	"./mira_search/mira_logo_sketch_1.gif": 189,
	"./mira_search/mira_mvp_header.png": 190,
	"./mira_search/mira_old_UI.png": 191,
	"./mira_search/mira_old_UI_transparent.png": 192,
	"./mira_search/mira_search_header.png": 193,
	"./mira_search/mira_search_principle.png": 194,
	"./mira_search/mira_search_principle_angle.png": 195,
	"./mira_search/mira_search_principle_angle2.png": 196,
	"./mira_search/mira_search_prototype.png": 197,
	"./mira_search/mira_search_prototype_laptop.png": 198,
	"./mira_search/mira_search_t_header.png": 199,
	"./mira_search/mira_search_t_header_old.png": 200,
	"./mira_search/mira_search_ui_prototype1.gif": 201,
	"./mira_search/prototyping_header.png": 202,
	"./mira_search/search_analytics_1.png": 203,
	"./mira_search/search_analytics_2.png": 204,
	"./mira_search/search_competitive_research.png": 205,
	"./mira_search/search_design_iteration_1.png": 206,
	"./mira_search/search_design_iteration_2.png": 207,
	"./mira_search/search_design_iteration_3.png": 208,
	"./mira_search/search_filters.png": 209,
	"./mira_search/search_home_tabs.png": 210,
	"./mira_search/search_iteration_analytics.png": 211,
	"./mira_search/search_iteration_pain_points.png": 212,
	"./mira_search/search_iteration_surveys_1.png": 213,
	"./mira_search/search_iteration_surveys_2.png": 214,
	"./mira_search/search_iteration_surveys_3.png": 215,
	"./mira_search/search_iteration_surveys_4.png": 216,
	"./mira_search/search_iteration_surveys_5.png": 217,
	"./mira_search/search_iteration_synthesis.png": 218,
	"./mira_search/search_prototype_results.png": 219,
	"./mira_search/search_prototype_results_blur.png": 220,
	"./mira_search/search_prototype_results_shaded.png": 221,
	"./mira_search/search_suggestions_1.png": 222,
	"./mira_search/search_suggestions_2.png": 223,
	"./mira_search/search_web_1.png": 224,
	"./mira_search/search_web_1b.png": 225,
	"./mira_search/search_web_1c.png": 226,
	"./mira_search/search_web_2.png": 227,
	"./mira_search/search_web_2b.png": 228,
	"./mira_search/search_web_2c.png": 229,
	"./mira_search/search_web_3.png": 230,
	"./mira_search/testing_surveys.png": 231,
	"./mira_search/testing_surveys2.png": 232,
	"./mira_search/typeahead_design.png": 233,
	"./mira_search/ui_design_header.png": 234,
	"./mira_search/user_interview.png": 235,
	"./mira_search/user_interview_small.png": 236,
	"./mira_search/visual_redesign.png": 237,
	"./mira_search/whiteboard_sketches.jpeg": 238,
	"./mira_search_thumb.png": 239,
	"./mira_search_thumb_old.png": 240
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 30;